import { ChevronDown } from 'lucide-react';
import { Label } from '@/components/ui/label';
import type { CapabilityVisibility } from '@/types/capability-types';
import { CAPABILITY_VISIBILITY_META } from '@/lib/capability-visibility';

export type { CapabilityVisibility };

export const VISIBILITY_OPTIONS = CAPABILITY_VISIBILITY_META;

interface VisibilitySelectProps {
    value: CapabilityVisibility;
    onChange: (value: CapabilityVisibility) => void;
    className?: string;
}

export function VisibilitySelect({ value, onChange, className }: VisibilitySelectProps) {
    const inputClassName = className ??
        "w-full rounded-md border border-slate-200 bg-white py-2 px-3 text-sm font-medium text-slate-700 placeholder-slate-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary";

    return (
        <div className="space-y-2">
            <Label>Visibility</Label>
            <div className="relative">
                <select
                    value={value}
                    onChange={(e) => onChange(e.target.value as CapabilityVisibility)}
                    className={`${inputClassName} appearance-none pr-8`}
                >
                    {VISIBILITY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <ChevronDown size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
            </div>
            <p className="text-xs text-slate-400">
                {VISIBILITY_OPTIONS.find((o) => o.value === value)?.description ?? ''}
            </p>
        </div>
    );
}
